<script setup>
defineProps({
  content: { type: Object, required: true },
  variant: { type: String, default: 'gallery-01' },
})
</script>

<template>
  <section class="b2-gallery" :class="`variant-${variant}`">
    <div class="b2-section-intro b2-centered">
      <div class="b2-section-label">{{ content.label.value }}</div>
      <h2 class="b2-section-title">{{ content.title.value }}</h2>
    </div>
    <div class="b2-gallery-grid">
      <div
        v-for="(img, i) in content.images.value"
        :key="i"
        class="b2-gallery-item"
        :class="img.size"
      >
        <img :src="img.url" :alt="img.caption" />
        <div class="b2-gallery-caption">{{ img.caption }}</div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.b2-gallery { padding: 100px 40px; max-width: 1200px; margin: 0 auto; }
.b2-section-label { font-size: 11px; font-weight: 500; letter-spacing: .2em; text-transform: uppercase; color: #4a8c3f; margin-bottom: 14px; }
.b2-section-title { font-family: 'Playfair Display', serif; font-size: clamp(30px, 4vw, 50px); font-weight: 700; color: #1a3320; line-height: 1.15; margin-bottom: 16px; }
.b2-section-intro.b2-centered { text-align: center; }
.b2-gallery-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px; margin-top: 48px; }
.b2-gallery-item { position: relative; overflow: hidden; border-radius: 4px; cursor: pointer; }
.b2-gallery-item.tall { grid-row: span 2; }
.b2-gallery-item.wide { grid-column: span 2; }
.b2-gallery-item img { width: 100%; height: 100%; min-height: 220px; object-fit: cover; transition: transform .5s ease; display: block; }
.b2-gallery-item:hover img { transform: scale(1.06); }
.b2-gallery-caption { position: absolute; bottom: 0; left: 0; right: 0; background: linear-gradient(transparent, rgba(0,0,0,.65)); color: white; padding: 30px 16px 14px; font-size: 14px; font-weight: 500; opacity: 0; transition: opacity .3s; }
.b2-gallery-item:hover .b2-gallery-caption { opacity: 1; }
.variant-gallery-03 { max-width: none; background: #f5f9f4; }
.variant-gallery-03 .b2-gallery-grid { grid-template-columns: repeat(4, minmax(280px, 1fr)); overflow-x: auto; padding-bottom: 14px; scroll-snap-type: x mandatory; }
.variant-gallery-03 .b2-gallery-item, .variant-gallery-03 .b2-gallery-item.tall, .variant-gallery-03 .b2-gallery-item.wide { grid-column: span 1; grid-row: span 1; height: 420px; scroll-snap-align: start; }
.variant-gallery-03 .b2-gallery-caption { opacity: 1; }
@media (max-width: 768px) {
  .b2-gallery-grid { grid-template-columns: 1fr 1fr; }
  .b2-gallery-item.tall, .b2-gallery-item.wide { grid-column: span 1; grid-row: span 1; }
}
</style>
